import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, ImageListItemBar } from "@mui/material";
import ImageListMUI from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { Colors } from "../theme/colors";

type IProps = {
  images: any[];
  handleAction?: any;
};

const ImageList: React.FC<IProps> = ({ images, handleAction }) => {
  return (
    <ImageListMUI cols={3} sx={images.length > 3 ? { height: 300 } : {}}>
      {images.map((image: any, index: number) => (
        <ImageListItem key={image.id || index}>
          <img
            crossOrigin="anonymous"
            src={image.url}
            srcSet={image.url}
            alt="event"
            loading="lazy"
          />
          {handleAction && (
            <ImageListItemBar
              sx={{
                background: "transparent",
                m: 1,
              }}
              position="top"
              actionIcon={
                <IconButton
                  sx={{
                    backgroundColor: Colors.white,
                    "&:hover": {
                      backgroundColor: Colors.white,
                    },
                  }}
                  onClick={() => handleAction(image)}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              }
              actionPosition="right"
            />
          )}
        </ImageListItem>
      ))}
    </ImageListMUI>
  );
};
export default ImageList;
